import { createFileRoute } from '@tanstack/react-router'
import { Layout } from '@/components/custom/layout'
import WorkflowHistory from '@/components/workflow/history'

export const Route = createFileRoute('/_auth/automation/history/$id')({
  component: WorkflowWHistoryWrapper,
})

export default function WorkflowWHistoryWrapper() {
  const { id } = Route.useParams()

  return (
    <Layout.Body>
      <WorkflowHistory id={id} />
    </Layout.Body>
  )
}
